/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';
import { useRecoilValue } from 'recoil';
import { permissionStore } from '../../store';
import { menus } from '@/config';
import { getApiEnv, getDomain } from '@/utils/utils';

const NoPermission = () => {
  const permissions = useRecoilValue(permissionStore);
  const navigate = useNavigate();

  const goHome = () => {
    if (permissions?.length > 0) {
      const firstHasPermissionMenu = menus?.find((m) => m.code === permissions[0]);
      if (firstHasPermissionMenu) {
        navigate(firstHasPermissionMenu.path);
      }
    } else {
      window.open(
        `${
          window.location.hostname === 'localhost'
            ? `http://localhost:8284`
            : `${window.location.protocol}//standard${getApiEnv()}.${getDomain()}`
        }`,
        '_self',
      );
    }
    // if (permissions?.includes('transfer_manager')) {
    //   navigate('/oss-status/list');
    // } else if (permissions?.includes('sys_manager')) {
    //   navigate('/oss-enterprise/list');
    // } else if (permissions?.includes('rule_manager')) {
    //   navigate('/rule-config/rules');
    // }
  };

  useEffect(() => {
    if (permissions?.length > 0) {
      const firstHasPermissionMenu = menus?.find((m) => m.code === permissions[0]);
      if (firstHasPermissionMenu) {
        navigate(firstHasPermissionMenu.path);
      }
    }
  }, [permissions]);

  return (
    <Result
      status="403"
      title="403"
      subTitle="抱歉，你无权访问该页面"
      extra={
        permissions?.length > 0 ? (
          <Button type="primary" onClick={goHome}>
            <span>返回首页</span>
          </Button>
        ) : undefined
      }
    />
  );
};

export default NoPermission;
